import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { SharePointReportProfileAlertPermissionsModel } from '../../../microsoft/sharepoint/profile/share-point-report-profile-alert-permissions-model';

export class SharePointReportProfileAlertExternalPermissionsModel extends ReportProfileAlertResourceBaseModel {
  permissions: SharePointReportProfileAlertPermissionsModel[];
}
